module.exports = __webpack_public_path__ + "img/logo.95c60b3f.svg";